import React from "react";
import { SnackbarContent, SnackbarKey, useSnackbar } from "notistack";
import { Paper, Typography, Button, Stack, IconButton } from "@mui/material";
import { MdClose } from "react-icons/md";
import { useNavigate } from "react-router-dom";

interface NotificationToastProps {
  id: SnackbarKey;
  title: string;
  body: string;
  route?: string;
}

const NotificationToast = React.forwardRef<HTMLDivElement, NotificationToastProps>(
  ({ id, title, body, route }, ref) => {
    const navigate = useNavigate();
    const { closeSnackbar } = useSnackbar();

    const handleView = () => {
      if (route) {
        navigate(route);
      }
      closeSnackbar(id);
    };

    console.log("🍞 NotificationToast rendering for:", title);

    return (
      <SnackbarContent ref={ref} style={{ zIndex: 9999, display: 'block' }}>
        <Paper
          sx={{
            width: "100%",
            minWidth: "300px",
            maxWidth: "400px",
            p: 2,
            backgroundColor: (theme) => theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: 3,
            border: (theme) => `1px solid ${theme.palette.divider}`,
          }}
        >
          <Stack direction="column" spacing={1}>
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography variant="subtitle1" fontWeight="bold">
                {title}
              </Typography>
              <IconButton size="small" onClick={() => closeSnackbar(id)}>
                <MdClose />
              </IconButton>
            </Stack>
            <Typography variant="body2" color="text.secondary">
              {body}
            </Typography>
            {route && (
              <Stack direction="row" justifyContent="flex-end">
                <Button size="small" variant="contained" onClick={handleView}>
                  View
                </Button>
              </Stack>
            )}
          </Stack>
        </Paper>
      </SnackbarContent>
    );
  }
);

NotificationToast.displayName = "NotificationToast";

export default NotificationToast;
